webpackJsonp([59],{

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1084);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("33a0bf69", content, true);

/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.content-tabs[data-v-56f3c73b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.footer-container[data-v-56f3c73b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/implementers/page-implementers-company.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"page-implementers-company.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.content-tabs[data-v-56f3c73b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.footer-container[data-v-56f3c73b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-implementers-company"},[_c('action-sidebar',{attrs:{"title":"Empresas","value":true},on:{"close-modal":_vm.closeModal}},[_c('v-tabs',{attrs:{"right":"","slider-color":"cyan"},model:{value:(_vm.tabsCompany),callback:function ($$v) {_vm.tabsCompany=$$v},expression:"tabsCompany"}},_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t"+_vm._s(item.name)+"\n\t\t")])})),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tabsCompany),callback:function ($$v) {_vm.tabsCompany=$$v},expression:"tabsCompany"}},[_c('v-tab-item',[_c('app-table',{staticClass:"mt-4 px-2",attrs:{"selectable":"","check-all":_vm.checkAll,"name":"assign-company","columns":_vm.columns,"rows":_vm.companies,"current-page":_vm.currentPage,"selected-value":_vm.selectedValue,"last-page":_vm.lastPage},on:{"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected,"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.ruc)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.nombreComercial)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.template ? props.row.template.data.items.data.name : null)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.template ? props.row.template.data.name : null)+"\n\t\t\t\t\t")])]}}])})],1),_vm._v(" "),_c('v-tab-item',[_c('app-table',{staticClass:"mt-4 px-2",attrs:{"check-all":_vm.checkAllDeallocated,"selectable":"","name":"assign-company","columns":_vm.columns,"rows":_vm.companiesDeallocated,"current-page":_vm.currentPageDeallocated,"last-page":_vm.lastPageDeallocated,"selected-value":_vm.selectedValueDeallocated},on:{"row-is-selected":_vm.rowIsSelectedDeallocated,"on-selected-all":_vm.allIsSelectedDeallocated,"on-page":_vm.changePageDeallocated,"on-search-event":_vm.onSearchDeallocated},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t"+_vm._s(props.row.ruc)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v(_vm._s(props.row.nombreComercial))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v(_vm._s(props.row.template ? props.row.template.data.items.data.name : null))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v(_vm._s(props.row.template ? props.row.template.data.name : null))])]}}])})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer pt-3 pb-3"},[_c('div',{staticClass:"footer-container"},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\tCancelar\n\t\t\t\t"),_c('img',{staticClass:"ml-2",attrs:{"src":(_vm.$imageUrl + "/icon-cancel.svg"),"alt":""}})]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-1",attrs:{"color":"success","disabled":_vm.disabledAssign(1)},on:{"click":_vm.btnAssignCompany}},[_vm._v("\n\t\t\t\tAsignar\n\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-1",attrs:{"color":"success","disabled":_vm.disabledDeallocated(0)},on:{"click":_vm.btnDeallocated}},[_vm._v("\n\t\t\t\tDesasignar\t\t\n\t\t\t")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_implementers_company_vue__ = __webpack_require__(858);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f3c73b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_implementers_company_vue__ = __webpack_require__(1085);
function injectStyle (ssrContext) {
  __webpack_require__(1083)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56f3c73b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_implementers_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f3c73b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_implementers_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(149);




var btnDeallocated = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var ids, body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						ids = this.dataSelectedDeallocated.map(function (p) {
							return p.id;
						});
						body = {
							companiesIds: ids
						};
						_context.prev = 2;
						_context.next = 5;
						return this.$http.delete('implementers/' + this.id + '/companies', { data: body });

					case 5:
						this.showNotification('Fueron desasignados correctamente');
						this.closeModal();
						this.loadDataDeallocated();
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 10]]);
	}));

	return function btnDeallocated() {
		return _ref.apply(this, arguments);
	};
}();

var btnAssignCompany = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var companiesIds;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						companiesIds = this.dataSelected.map(function (action) {
							return action.id;
						});
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.post('implementers/' + this.id + '/companies', { companiesIds: companiesIds });

					case 4:
						this.showNotification('Las compañias fueron asignados correctamente');
						this.closeModal();
						this.loadData();
						_context2.next = 12;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 9]]);
	}));

	return function btnAssignCompany() {
		return _ref2.apply(this, arguments);
	};
}();

var loadDataDeallocated = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.searchDeallocated,
							perPage: 30,
							isSelected: 1
						};
						_context3.next = 3;
						return this.$http.get('implementers/' + this.id + '/companies', { params: params });

					case 3:
						response = _context3.sent;

						this.companiesDeallocated = response.data.data;
						this.lastPageDeallocated = Number(response.headers['x-last-page']);

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadDataDeallocated() {
		return _ref3.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						params = {
							isSelected: 0,
							page: this.params.page,
							perPage: 30,
							search: this.params.search
						};
						_context4.next = 3;
						return this.$http.get('implementers/' + this.id + '/companies', { params: params });

					case 3:
						response = _context4.sent;

						this.companies = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);

					case 6:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function loadData() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function disabledAssign(value) {
	return this.tabsCompany === value || this.dataSelected.length < 1;
}

function disabledDeallocated(value) {
	return this.tabsCompany === value || this.dataSelectedDeallocated.length < 1;
}

function rowIsSelected(row) {
	this.companies = this.selectIsRow(this.companies, this.selectedValue, row);
	this.checkAll = this.every(this.companies, this.selectedValue);
	this.dataSelected = this.companies.filter(function (r) {
		return r.flagSelected;
	});
}

function rowIsSelectedDeallocated(row) {
	this.companiesDeallocated = this.selectIsRow(this.companiesDeallocated, this.selectedValueDeallocated, row);
	this.checkAllDeallocated = this.every(this.companies, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.companiesDeallocated.filter(function (r) {
		return r.flagDeallocated;
	});
}

function onSearch(value) {
	this.params.search = value ? value.trim() : null;
	this.loadData();
}

function onSearchDeallocated(search) {
	this.params.searchDeallocated = search ? search.trim() : null;
	this.loadDataDeallocated();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData();
}

function changePageDeallocated(page) {
	this.params.page = page;
	this.currentPageDeallocated = page;
	this.loadDataDeallocated();
}

function allIsSelectedDeallocated(checked) {
	var _this = this;

	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.companiesDeallocated = this.companiesDeallocated.map(function (item) {
		var newRowDeallocated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		newRowDeallocated.isSelected = checked;
		if (checked) {
			_this.dataSelectedDeallocated.push(item);
		}
		return newRowDeallocated;
	});
	this.companiesDeallocated = this.selectIsRow(this.companiesDeallocated, this.selectedValueDeallocated, false, checked);
}

function allIsSelected(checked) {
	var _this2 = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.companies = this.companies.map(function (element) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newRow.isSelected = checked;
		if (checked) {
			_this2.dataSelected.push(element);
		}
		return newRow;
	});
	this.companies = this.selectIsRow(this.companies, this.selectedValue, false, checked);
}

function created() {
	this.loadData();
	this.loadDataDeallocated();
}

function data() {
	return {
		checkAll: false,
		checkAllDeallocated: false,
		columns: [{ id: 1, name: 'Ruc', value: 'ruc', checked: true, visible: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 3, name: 'Rubro', value: 'rubro', checked: true, visible: true }, { id: 4, name: 'Template', value: 'template', checked: true, visible: true }],
		columnsAppoint: [{ id: 1, name: 'Ruc', value: 'ruc', checked: true, visible: true }, { id: 2, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 3, name: 'Compañia', value: 'company', checked: true, visible: true }, { id: 4, name: 'Rubro', value: 'rubro', checked: true, visible: true }, { id: 5, name: 'Template', value: 'template', checked: true, visible: true }],
		companies: [],
		companiesDeallocated: [],
		currentPage: 1,
		currentPageDeallocated: 1,
		dataSelected: [],
		dataSelectedDeallocated: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		rows: [],
		rowsAppoint: [],
		selectedValue: 'flagSelected',
		selectedValueDeallocated: 'flagDeallocated',
		tabsCompany: null,
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}]
	};
}

function closeModal() {
	this.goTo('page-config-implementers');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-implementers-company',
	created: created,
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		allIsSelectedDeallocated: allIsSelectedDeallocated,
		btnAssignCompany: btnAssignCompany,
		btnDeallocated: btnDeallocated,
		changePage: changePage,
		changePageDeallocated: changePageDeallocated,
		closeModal: closeModal,
		disabledAssign: disabledAssign,
		disabledDeallocated: disabledDeallocated,
		loadData: loadData,
		loadDataDeallocated: loadDataDeallocated,
		rowIsSelected: rowIsSelected,
		rowIsSelectedDeallocated: rowIsSelectedDeallocated,
		onSearch: onSearch,
		onSearchDeallocated: onSearchDeallocated
	},
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"]
	},
	props: {
		id: {
			type: [Number, String]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/59.0174ed8bfa60a696047e.js